export default __webpack_public_path__ + "static/media/location.75240ecf.png";